@if(fetchStatus().isLoading && data().pagination === 0 ) {

<app-skeleton-competition-with-matches [nItem]="10" />
}

<div class="flex flex-col gap-4" #soccerMatchesContainer>
  @if(!fetchStatus().isError && !fetchStatus().isLoading &&
  data().soccerMatches.length === 0) {

  <app-no-result message="NotMatchesAvalaible" />

  }

  <!--  -->

  @for (competition of data().soccerMatches; track competition.Id) {
  <app-entity-favorite-row [entity]="'Competition'" [data]="competition" />

  }
</div>
<div #scrollTrigger style="height: 1px"></div>

@if(fetchStatus().isLoading && data().pagination > 0) {

<app-skeleton-competition-with-matches [nItem]="4" />

}
<!--  -->
@if(fetchStatus().isError && data().soccerMatches.length === 0 ) {
<app-no-result message="NotAvalaibleCompetitions" />

}
